import React from "react";
import { useTranslation } from "react-i18next";
import "./Modules.css";

const Voorwaardengids = () => {
  const { t } = useTranslation();

  return (
    <div className="main-container">
      <span>{t("voorwaardengids")}</span>
    </div>
  );
};

export default Voorwaardengids;
